import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import InfoIcon from '@mui/icons-material/Info'
import ErrorIcon from '@mui/icons-material/Error'

import { theme } from '../../themes/theme'
import { MedBodyText } from '../styles/Text'
import { SUCCESS, SUCCESS_LIGHT } from '../styles/colors'

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  margin: 0;
  font-size: 12px;

  border-radius: ${theme.borderRadius.div};

  .MuiSvgIcon-root {
    width: 18px;
    height: 18px;
  }
`

const InfoContainer = styled(MessageContainer)`
  background: ${theme.colors.primaryLight};

  .MuiSvgIcon-root {
    color: ${theme.colors.primary};
  }
`

const ProcessingContainer = styled(MessageContainer)`
  background: rgba(208, 112, 16, 0.1);

  .MuiSvgIcon-root {
    color: rgba(208, 112, 16, 1);
  }
`

const Spinner = styled(CircularProgress)`
  color: rgba(208, 112, 16, 1);
`

const SuccessContainer = styled(MessageContainer)`
  background: ${SUCCESS_LIGHT};

  .MuiSvgIcon-root {
    color: ${SUCCESS};
  }
`

const ErrorContainer = styled(MessageContainer)`
  background: ${theme.colors.errorLight};

  .MuiSvgIcon-root {
    color: ${theme.colors.error};
  }
`

const WarningContainer = styled(MessageContainer)`
  background: rgba(208, 198, 16, 0.1);

  .MuiSvgIcon-root {
    color: rgba(208, 198, 16, 1);
  }
`

const InfoMessage = ({ children }) => (
  <InfoContainer>
    <InfoIcon size={15} />
    <MedBodyText>{children}</MedBodyText>
  </InfoContainer>
)

const ProcessingMessage = ({ children }) => (
  <ProcessingContainer>
    <Spinner size={15} />
    <MedBodyText>{children}</MedBodyText>
  </ProcessingContainer>
)

const SuccessMessage = ({ children }) => (
  <SuccessContainer>
    <CheckCircleIcon size={15} />
    <MedBodyText>{children}</MedBodyText>
  </SuccessContainer>
)

const OrangeErrorMessage = ({ children }) => (
  <ProcessingContainer>
    <ErrorIcon size={15} />
    <MedBodyText>{children}</MedBodyText>
  </ProcessingContainer>
)

const ErrorMessage = ({ children }) => (
  <ErrorContainer role="alert">
    <ErrorIcon size={15} />
    <MedBodyText>{children ?? 'Hm, an error occurred. Try again.'}</MedBodyText>
  </ErrorContainer>
)

const WarningMessage = ({ children }) => (
  <WarningContainer>
    <ErrorIcon size={15} />
    {children}
  </WarningContainer>
)

InfoMessage.propTypes = {
  children: PropTypes.node
}

ProcessingMessage.propTypes = {
  children: PropTypes.node
}

SuccessMessage.propTypes = {
  children: PropTypes.node
}

ErrorMessage.propTypes = {
  children: PropTypes.node
}

WarningMessage.propTypes = {
  children: PropTypes.node
}

OrangeErrorMessage.propTypes = {
  children: PropTypes.node
}

export { InfoMessage, ProcessingMessage, SuccessMessage, ErrorMessage, WarningMessage, OrangeErrorMessage }
